// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Effect_Class from "../Effect.Class/index.js";
var replaceHash = function (dictMonadEffect) {
    return function (h) {
        return Effect_Class.liftEffect(dictMonadEffect)(function () {
            return $foreign["_replaceHash"](h);
        });
    };
};
var pushHash = function (dictMonadEffect) {
    return function (h) {
        return Effect_Class.liftEffect(dictMonadEffect)(function () {
            return $foreign["_pushHash"](h);
        });
    };
};
export {
    _pushHash,
    _replaceHash
} from "./foreign.js";
export {
    pushHash,
    replaceHash
};
//# sourceMappingURL=index.js.map
